var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLoadMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3343_46055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 5.96371C10.5561 5.96371 11.009 5.51087 11.009 4.95459V2.93636C11.009 2.38005 10.5561 1.92725 9.99984 1.92725C9.44356 1.92725 8.99072 2.38005 8.99072 2.93636V4.95459C8.99072 5.51087 9.44356 5.96371 9.99984 5.96371Z",
    fill: "#523280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9541 8.99097H2.93587C2.3796 8.99097 1.92676 9.44377 1.92676 10.0001C1.92676 10.5564 2.3796 11.0092 2.93587 11.0092H4.9541C5.51041 11.0092 5.96322 10.5564 5.96322 10.0001C5.96322 9.44377 5.51041 8.99097 4.9541 8.99097Z",
    fill: "#523280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29148 15.7084C4.48215 15.8991 4.73542 16.004 5.00495 16.004C5.27446 16.004 5.52773 15.8991 5.71843 15.7084L7.14538 14.2814C7.53858 13.8882 7.53858 13.2477 7.14538 12.8545C6.75218 12.4613 6.11163 12.4613 5.71843 12.8545L4.29148 14.2814C3.89828 14.6746 3.89828 15.3152 4.29148 15.7084Z",
    fill: "#523280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99072 17.064C8.99072 17.6202 9.44356 18.0731 9.99984 18.0731C10.5561 18.0731 11.009 17.6202 11.009 17.064V15.0457C11.009 14.4894 10.5561 14.0366 9.99984 14.0366C9.44356 14.0366 8.99072 14.4894 8.99072 15.0457V17.064Z",
    fill: "#523280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.854 14.2814L14.2809 15.7084C14.4716 15.8991 14.7249 16.004 14.9944 16.004C15.2639 16.004 15.5172 15.8991 15.7079 15.7084C16.1011 15.3152 16.1011 14.6746 15.7079 14.2814L14.2809 12.8545C13.8877 12.4613 13.2472 12.4613 12.854 12.8545C12.4608 13.2477 12.4608 13.8882 12.854 14.2814Z",
    fill: "#523280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0635 8.99097H15.0452C14.489 8.99097 14.0361 9.44377 14.0361 10.0001C14.0361 10.5564 14.489 11.0092 15.0452 11.0092H17.0635C17.6198 11.0092 18.0726 10.5564 18.0726 10.0001C18.0726 9.44377 17.6198 8.99097 17.0635 8.99097Z",
    fill: "#523280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5675 7.44127C13.837 7.44127 14.0902 7.33634 14.2809 7.14563L15.7079 5.71868C16.1011 5.32548 16.1011 4.68493 15.7079 4.29173C15.3147 3.89852 14.6741 3.89853 14.2809 4.29173L12.854 5.71868C12.4608 6.11188 12.4608 6.75243 12.854 7.14563C13.0447 7.33634 13.2979 7.44127 13.5675 7.44127Z",
    fill: "#523280"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3343_46055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6667,
    height: 16.6667,
    fill: "white",
    transform: "translate(1.6665 1.66675)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoadMore);
export default __webpack_public_path__ + "static/media/icon-load-more.a00a9fab83d0e7b8652df48e510fd762.svg";
export { ForwardRef as ReactComponent };